import React, { useMemo, useState } from "react";
import { ABtn, AResult, AScore } from "./arcadeUi";

const shuffle = () => {
  const a = Array.from({ length: 25 }, (_, i) => i + 1);
  for (let i = a.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [a[i], a[j]] = [a[j], a[i]]; }
  return a;
};

// count completed lines (rows, cols, diagonals) for a 5x5 marked set
const countLines = (grid, marked) => {
  let n = 0;
  for (let r = 0; r < 5; r++) if (grid.slice(r * 5, r * 5 + 5).every((v) => marked.has(v))) n++;
  for (let c = 0; c < 5; c++) if ([0, 1, 2, 3, 4].every((r) => marked.has(grid[r * 5 + c]))) n++;
  if ([0, 1, 2, 3, 4].every((i) => marked.has(grid[i * 5 + i]))) n++;
  if ([0, 1, 2, 3, 4].every((i) => marked.has(grid[i * 5 + (4 - i)]))) n++;
  return Math.min(n, 5);
};
const WORD = "BINGO";

export default function Bingo() {
  const [seed, setSeed] = useState(0);
  const yourGrid = useMemo(shuffle, [seed]);
  const cpuGrid = useMemo(shuffle, [seed]);
  const [called, setCalled] = useState(new Set());
  const [yourMark, setYourMark] = useState(new Set());
  const [cpuMark, setCpuMark] = useState(new Set());
  const [current, setCurrent] = useState(null);

  const yourLines = countLines(yourGrid, yourMark);
  const cpuLines = countLines(cpuGrid, cpuMark);
  const over = yourLines >= 5 || cpuLines >= 5;

  const draw = () => {
    if (over) return;
    const remaining = [];
    for (let i = 1; i <= 25; i++) if (!called.has(i)) remaining.push(i);
    if (!remaining.length) return;
    const num = remaining[Math.floor(Math.random() * remaining.length)];
    setCurrent(num);
    setCalled((s) => new Set(s).add(num));
    setYourMark((s) => new Set(s).add(num)); // auto-mark (tap also works)
    setCpuMark((s) => new Set(s).add(num));
  };

  const tap = (num) => { if (called.has(num)) setYourMark((s) => new Set(s).add(num)); };

  const restart = () => {
    setSeed((v) => v + 1); setCalled(new Set()); setYourMark(new Set()); setCpuMark(new Set()); setCurrent(null);
  };

  const Letters = ({ n }) => (
    <span className="font-signboard text-lg font-bold tracking-widest">
      {WORD.split("").map((c, i) => (
        <span key={c} className={i < n ? "text-kirana-red" : "text-kirana-brown/25"}>{c}</span>
      ))}
    </span>
  );

  return (
    <div className="w-full text-center">
      <div className="flex flex-wrap items-center justify-center gap-2">
        <AScore label="Called" value={called.size} />
        <span className="rounded-md border-2 border-kirana-brown bg-white px-2.5 py-1 text-sm font-bold">You <Letters n={yourLines} /></span>
        <span className="rounded-md border-2 border-kirana-brown bg-white px-2.5 py-1 text-sm font-bold">CPU <Letters n={cpuLines} /></span>
      </div>

      <div className="my-3 flex items-center justify-center gap-3">
        <div className="flex h-14 w-14 items-center justify-center rounded-full border-[3px] border-kirana-brown bg-kirana-gold font-signboard text-3xl font-bold text-kirana-brown" data-testid="bingo-current">
          {current ?? "—"}
        </div>
        {!over && <ABtn data-testid="bingo-draw" onClick={draw} tone="red">Call Number</ABtn>}
      </div>

      <div className="mx-auto grid w-full max-w-[300px] grid-cols-5 gap-1.5" data-testid="bingo-grid">
        {yourGrid.map((num) => {
          const marked = yourMark.has(num);
          return (
            <button key={num} data-testid={`bingo-cell-${num}`} onClick={() => tap(num)}
              className={`flex aspect-square items-center justify-center rounded-md border-2 border-kirana-brown text-sm font-bold transition-colors ${marked ? "bg-kirana-red text-white" : "bg-white text-kirana-brown"}`}>
              {num}
            </button>
          );
        })}
      </div>

      {over && (
        <>
          <AResult testId="bingo-result" win={yourLines >= 5} text={yourLines >= 5 ? "B-I-N-G-O! You Win 🎉" : "CPU shouted BINGO first 😜"} />
          <div className="mt-3 flex justify-center"><ABtn data-testid="bingo-again" onClick={restart} tone="green">New Ticket</ABtn></div>
        </>
      )}
    </div>
  );
}
